import {CodeAndExchange} from "../../../../../../instruments/types/CodeAndExchange";
import {SelectedNewsSources} from "../../../../../../news/components/news-source-selector/model/SelectedNewsSources";

export enum ChangeType {
    SECURITY,
    SOURCES
}

export interface NewsWidgetConfigChange {
    readonly type: ChangeType;
}

export interface NewsWidgetSecurityChange extends NewsWidgetConfigChange {
    readonly type: ChangeType.SECURITY;
    readonly security: CodeAndExchange;
}

export function SecurityChange(security: CodeAndExchange): NewsWidgetSecurityChange {
    return {
        type: ChangeType.SECURITY,
        security
    };
}

export function isSecurityChange(change: NewsWidgetConfigChange): change is NewsWidgetSecurityChange {
    return change.type === ChangeType.SECURITY;
}

export interface NewsWidgetSourcesChange extends NewsWidgetConfigChange {
    readonly type: ChangeType.SOURCES;
    readonly sources: SelectedNewsSources;
}

export function SourcesChange(sources: SelectedNewsSources): NewsWidgetSourcesChange {
    return {
        type: ChangeType.SOURCES,
        sources
    };
}

export function isSourcesChange(change: NewsWidgetConfigChange): change is NewsWidgetSourcesChange {
    return change.type === ChangeType.SOURCES;
}
